<template>
  <section class="page-container">
    <div class="toolbar">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.id" placeholder="id"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.mobile" placeholder="mobile"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="filters.nickname" placeholder="nickname"></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.timeRange"
            type="datetimerange"
            value-format="timestamp"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="Begin time"
            end-placeholder="End time"
            align="right"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="list">search</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">add</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      v-loading="listLoading"
      :data="results"
      highlight-current-row
      stripe
      border
      :height="tableHeight"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-descriptions :column="3" border size="mini" style="margin: 0 10px">
            <el-descriptions-item label="Username：">{{ scope.row.username }}</el-descriptions-item>
            <el-descriptions-item label="Status：">
              {{ scope.row.status === 0 ? "normal" : "deleted" }}
            </el-descriptions-item>
            <el-descriptions-item v-if="scope.row.forbidden" label="Muted">
              <span v-if="scope.row.forbiddenEndTime === -1">permanent</span>
              <span v-else>{{ scope.row.forbiddenEndTime | formatDate }}</span>
            </el-descriptions-item>
            <el-descriptions-item v-if="scope.row.roles && scope.row.roles.length" label="Roles">
              <el-tag
                v-for="role in scope.row.roles"
                :key="role"
                size="mini"
                style="margin-right: 3px"
                >{{ role }}
              </el-tag>
            </el-descriptions-item>
          </el-descriptions>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="id" width="100"></el-table-column>
      <el-table-column prop="avatar" label="avatar" width="80">
        <template slot-scope="scope">
          <avatar :user="scope.row" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="nickname"></el-table-column>
      <el-table-column prop="mobile" label="mobile"></el-table-column>
      <el-table-column prop="email" label="e-mail"></el-table-column>
      <el-table-column prop="score" label="score"></el-table-column>
      <el-table-column prop="level" label="level"></el-table-column>
      <el-table-column prop="forbidden" label="mute/unmute">
        <template slot-scope="scope">
          <span v-if="scope.row.forbidden" class="tag is-warning">muted</span>
          <span v-else class="tag is-success">normal</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="create date">
        <template slot-scope="scope">{{ scope.row.createTime | formatDate }} </template>
      </el-table-column>
      <el-table-column label="ops" width="200">
        <template slot-scope="scope">
          <el-dropdown size="mini" trigger="hover" placement="bottom" @command="handleCommand">
            <el-button type="primary">
              ops<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ cmd: 'edit', row: scope.row }">edit </el-dropdown-item>
              <el-dropdown-item
                v-if="scope.row.forbidden"
                :command="{ cmd: 'removeForbidden', row: scope.row }"
                >unmute
              </el-dropdown-item>
              <el-dropdown-item v-else :command="{ cmd: 'forbidden', row: scope.row }"
                >mute
              </el-dropdown-item>
              <el-dropdown-item :command="{ cmd: 'scoreLog', row: scope.row }"
                >score record
              </el-dropdown-item>
              <el-dropdown-item :command="{ cmd: 'addScore', row: scope.row }"
                >add score
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <my-pagination
      ref="pagebar"
      :page="page"
      @current-change="handlePageChange"
      @size-change="handleLimitChange"
    />

    <el-dialog :visible.sync="addFormVisible" :close-on-click-modal="false" title="add">
      <el-form ref="addForm" :model="addForm" :rules="addFormRules" label-width="80px">
        <el-form-item label="username" prop="username">
          <el-input v-model="addForm.username"></el-input>
        </el-form-item>

        <el-form-item label="nickname" prop="nickname">
          <el-input v-model="addForm.nickname"></el-input>
        </el-form-item>

        <el-form-item label="email" prop="email">
          <el-input v-model="addForm.email"></el-input>
        </el-form-item>

        <el-form-item label="password" prop="password">
          <el-input v-model="addForm.password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">Cancel</el-button>
        <el-button :loading="addLoading" type="primary" @click.native="addSubmit"
          >submit
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="editFormVisible" :close-on-click-modal="false" title="edit">
      <el-form ref="editForm" :model="editForm" :rules="editFormRules" label-width="80px">
        <el-input v-model="editForm.id" type="hidden"></el-input>
        <el-form-item label="username" prop="username">
          <el-input v-model="editForm.username"></el-input>
        </el-form-item>
        <el-form-item label="nickname" prop="nickname">
          <el-input v-model="editForm.nickname"></el-input>
        </el-form-item>
        <el-form-item label="e-mail" prop="email">
          <el-input v-model="editForm.email"></el-input>
        </el-form-item>
        <el-form-item label="role" prop="roles">
          <el-select
            v-model="editForm.roles"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="role"
            style="width: 100%"
          >
            <el-option
              v-for="item in editForm.roles"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="password" prop="password">
          <el-input v-model="editForm.password" placeholder="default"></el-input>
        </el-form-item>

        <el-form-item label="status" prop="status">
          <el-select v-model="editForm.status" placeholder="select">
            <el-option :key="0" :value="0" label="normal"></el-option>
            <el-option :key="1" :value="1" label="deleted"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">Cancel</el-button>
        <el-button :loading="editLoading" type="primary" @click.native="editSubmit"
          >submit
        </el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="forbiddenFormVisible" :close-on-click-modal="false" title="mute">
      <el-form ref="forbiddenForm" :model="forbiddenForm" label-width="80px">
        <el-input v-model="forbiddenForm.userId" type="hidden"></el-input>
        <el-form-item label="mute time" prop="reason">
          <el-select v-model="forbiddenForm.days">
            <el-option label="3 days" value="3" />
            <el-option label="5 days" value="3" />
            <el-option label="7 days" value="7" />
            <el-option label="15 days" value="15" />
            <el-option label="30 days" value="30" />
            <el-option label="permanent" value="-1" />
          </el-select>
        </el-form-item>
        <el-form-item label="mute reason" prop="reason">
          <el-select v-model="forbiddenForm.reason">
            <el-option value="advertise" />
            <el-option value="meaningless" />
            <el-option value="sex" />
            <el-option value="politics" />
            <el-option value="others" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="forbiddenFormVisible = false">Cancel</el-button>
        <el-button :loading="forbiddenLoading" type="primary" @click.native="forbidden"
          >mute
        </el-button>
      </div>
    </el-dialog>

    <score-log ref="scoreLog" />
  </section>
</template>

<script>
import MyPagination from "@/components/MyPagination";
import Avatar from "@/components/Avatar";
import ScoreLog from "./score-log";
export default {
  name: "Users",
  components: { MyPagination, Avatar, ScoreLog },
  data() {
    return {
      tableHeight: "700px",
      results: [],
      listLoading: false,
      page: {},
      filters: {
        id: "",
      },
      selectedRows: [],

      addForm: {
        username: "",
        nickname: "",
        avatar: "",
        email: "",
        roles: [],
        password: "",
        status: "",
      },
      addFormVisible: false,
      addFormRules: {},
      addLoading: false,

      editForm: {
        id: "",
        username: "",
        nickname: "",
        avatar: "",
        email: "",
        roles: [],
        password: "",
        status: "",
      },
      editFormVisible: false,
      editFormRules: {},
      editLoading: false,

      forbiddenForm: {
        userId: "",
        days: 0,
        reason: "",
      },
      forbiddenFormVisible: false,
      forbiddenLoading: false,

      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    list() {
      const me = this;
      me.listLoading = true;
      const params = Object.assign(me.filters, {
        page: me.page.page,
        limit: me.page.limit,
      });
      this.axios
        .form("base:/api/admin/user/list", params)
        .then((data) => {
          me.results = data.results;
          me.page = data.page;
        })
        .finally(() => {
          me.listLoading = false;
        });
    },
    handlePageChange(val) {
      this.page.page = val;
      this.list();
    },
    handleLimitChange(val) {
      this.page.limit = val;
      this.list();
    },
    handleAdd() {
      this.addForm = {
        name: "",
        description: "",
      };
      this.addFormVisible = true;
    },
    addSubmit() {
      const me = this;
      this.axios
        .form("base:/api/admin/user/create", this.addForm)
        .then((data) => {
          me.$message({ message: "Submit success", type: "success" });
          me.addFormVisible = false;
          me.list();
        })
        .catch((rsp) => {
          me.$elnotify.error({ title: "error ", message: rsp.message });
        });
    },
    handleEdit(row) {
      const me = this;
      this.axios
        .get(`/api/admin/user/${row.id}`)
        .then((data) => {
          me.editForm = Object.assign({}, data);
          me.editForm.password = "";
          me.editFormVisible = true;
        })
        .catch((rsp) => {
          me.$elnotify.error({ title: "error ", message: rsp.message });
        });
    },
    editSubmit() {
      const params = { ...this.editForm };
      if (params.roles && params.roles.length) {
        params.roles = params.roles.join(",");
      } else {
        params.roles = "";
      }
      const me = this;
      this.axios
        .form("base:/api/admin/user/update", params)
        .then((data) => {
          me.list();
          me.editFormVisible = false;
        })
        .catch((rsp) => {
          me.$elnotify.error({ title: "error ", message: rsp.message });
        });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    showForbiddenDialog(row) {
      this.forbiddenForm = {
        userId: row.id,
        days: 7,
        reason: "advertise",
      };
      this.forbiddenFormVisible = true;
    },
    async forbidden() {
      this.forbiddenLoading = true;
      try {
        await this.axios.form("base:/api/admin/user/forbidden", this.forbiddenForm);
        this.forbiddenForm = {};
        this.forbiddenFormVisible = false;
        this.$message.success("mute success");
        this.list();
      } catch (e) {
        this.$message.success("mute failed " + (e.message || e));
      } finally {
        this.forbiddenLoading = false;
      }
    },
    async removeForbidden(row) {
      try {
        await this.axios.form("base:/api/admin/user/forbidden", {
          userId: row.id,
          days: 0,
        });
        this.$message.success("unmute success");
        this.list();
      } catch (e) {
        this.$message.success("unmute failed " + (e.message || e));
      }
    },
    showScoreLog(row) {
      this.$refs.scoreLog.showLog(row.id);
    },
    handleCommand(cmd) {
      if (cmd.cmd === "edit") {
        this.handleEdit(cmd.row);
      } else if (cmd.cmd === "removeForbidden") {
        this.removeForbidden(cmd.row);
      } else if (cmd.cmd === "forbidden") {
        this.showForbiddenDialog(cmd.row);
      } else if (cmd.cmd === "scoreLog") {
        this.showScoreLog(cmd.row);
      } else if (cmd.cmd === "addScore") {
        this.addScore(cmd.row);
      }
    },
    addScore(row) {
      const me = this;
      this.$prompt("", row.nickname + " - add score", {
        confirmButtonText: "Yes",
        cancelButtonText: "Cancel",
        inputPattern: /^-?\d+$/,
        inputErrorMessage: "pls input correct number ",
      })
        .then(({ value }) => {
          me.axios
            .form("base:/api/admin/user/addscore", {
              userId: row.id,
              score: value,
            })
            .then((data) => {
              me.$message({
                type: "success",
                message: "successfully",
              });
            })
            .catch((e) => {
              this.$message({
                type: "info",
                message: e.message || e,
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Cancel",
          });
        });
    },
  },
};
</script>

<style scoped></style>
